/**
 * Convert a string to katakana (full-width)
 * 
 * @param {string} text - string to convert to katakana
 * @returns {string}
 * 
 * @example
 * const result = normalizeToKatakana('ち チ ﾁ');
 * console.log(result); // チ チ チ
 * 
 */
export function normalizeToKatakana(text) {
  // Normalize Unicode to NFKC form
  let normalized = text.normalize('NFKC');
  // Convert all Hiragana to Katakana
  normalized = normalized.replace(/[\u3041-\u3096]/g, (char) =>
    String.fromCharCode(char.charCodeAt(0) + 0x60)
  );

  // Katakana small to Katakana large conversion
  const smallToLargeMap = {
    'ァ': 'ア', 'ィ': 'イ', 'ゥ': 'ウ', 'ェ': 'エ', 'ォ': 'オ',
    'ッ': 'ツ', 'ャ': 'ヤ', 'ュ': 'ユ', 'ョ': 'ヨ',
    'ヮ': 'ワ',
    'ヵ': 'カ', 'ヶ': 'ケ'
  };

  return normalized.replace(/[\u30A1-\u30FA]/g, (char) =>
    smallToLargeMap[char] || char
  );
}